import React from 'react'
import List from './list'
export default () => {
    return (
        <div className="content">
            <List />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Categories/index.jsx